/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  OnClickOutside,
  previewLinkIcon,
  UrlPreview,
  userProfileHover,
} from "../Helpers/chatCommon";
import UserProfilePopOver from "../models/userProfilePopOver";
import { timestampToDateTime } from "../Helpers/common";
import AttachmentsFiles from "./attachmentFile";
import ChatUnpinAlert from "../models/ChatUnpinAlert";

const ChatboardPinnedIncoming = ({
  value,
  userInfo,
  lastMessage,
  handleJumpToMessage,
  handleUnpinMessage,
  pinnedActionHandler,
  pinnedActionsId,
  setPinnedActionId,
}) => {
  const actionRef = useRef(null);
  const allAttendeeList = useSelector((state) => state.call.allAttendeeList);
  const userProfileId = useSelector((state) => state.chat.userProfileId);
  const deletedMessageIds = useSelector(
    (state) => state.chat.deletedMessageIds,
  );
  const msgMentionId = useSelector((state) => state.chat.msgMentionId);
  const msgMentionUser = useSelector((state) => state.chat.msgMentionUser);
  const selectedLanguage = useSelector((state) => state.chat.selectedLanguage);
  const popupClass = useSelector((state) => state.chat.popupClass);
  let username = userInfo.name;
  let useravtar = userInfo.user_profile_image;

  const [showUnpin, setShowUnpin] = useState(false);
  const [unpinData, setUnpinData] = useState({});

  const getGroupUserInfo = () => {
    return allAttendeeList.find((item) => item.user_id === value.senderID);
  };

  if (userInfo.type == "group") {
    allAttendeeList.some((v) => {
      if (v?.user_id == value.senderID) {
        username = v.name;
        useravtar = v.user_profile_image;
      }
    });
  }
  let IsNewLineExist = null;
  if (value.message !== "c2-attach-files") {
    IsNewLineExist = /\r|\n/.exec(value.message);
  }

  const isUserOnline = useMemo(() => {
    return allAttendeeList.find((item) => item.user_id === value.senderID)
      ?.online
      ? true
      : false;
  }, [allAttendeeList, value.senderID]);

  const newMessage =
    IsNewLineExist !== null
      ? value.preview &&
        Array.isArray(value.preview) &&
        value.preview.length > 0
        ? value.message_array.join(" ")
        : value.message.replace(/ /g, "&nbsp;")
      : value.message.replace(/ /g, "&nbsp;");

  const lengthOfSplitMessage = newMessage?.split("\n").length;

  OnClickOutside(actionRef, () => setPinnedActionId(""));

  const handleUnpinAlert = (value) => {
    setUnpinData(value);
    setShowUnpin(true);
  };

  return (
    <>
      <div
        className={`chat_row ${lastMessage === true ? "mb-0" : ""} ${
          deletedMessageIds?.includes(value?.id) ? "chat_row_hide" : ""
        } ${value?.pinned && "highlight"} pointertab`}
        id={value.id}
        key={value.id}
        onMouseLeave={() => userProfileHover({})}
        onClick={() => handleJumpToMessage(value)}
      >
        <div className="w-100 d-flex  max-w-100">
          <div
            className="avatar"
            onMouseEnter={() => userProfileHover(value.id)}
          >
            {useravtar ? (
              // eslint-disable-next-line jsx-a11y/alt-text
              <img className="h-100" src={`${useravtar}`}></img>
            ) : (
              <svg viewBox="3 2 18 19">
                <path
                  fill="#425b76"
                  d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                ></path>
              </svg>
            )}
            <span className={`status ${isUserOnline && "online"}`}></span>
            {(userProfileId === value.id ||
              (msgMentionId === value.msgUniqueID &&
                value.type === "group")) && (
              <UserProfilePopOver
                userInfo={
                  msgMentionId === value.msgUniqueID
                    ? allAttendeeList?.find(
                        (userItem) => userItem?.user_id === msgMentionUser,
                      ) ?? {}
                    : userInfo.type == "group"
                    ? getGroupUserInfo()
                    : userInfo
                }
                popupClass={popupClass}
                selectedLanguage={selectedLanguage}
              />
            )}
          </div>
          <div
            className={`bubble inner-bubble ${
              value.isReply === true && "reply"
            }`}
          >
            {value.isReply === true && (
              <h3 className="Name-messenger">{username} </h3>
            )}
            <div className={`${value.isReply === true && "reply-inner"}`}>
              {value.isReply === true ? (
                <h3 className="Name-messenger flex-column align-items-start">
                  <div>
                    <p
                      className="break-words text-grey"
                      dangerouslySetInnerHTML={{ __html: value.earlyMessage }}
                    />
                    <div className="time ml-0 mt-1">
                      {allAttendeeList?.find(
                        (findItem) =>
                          findItem.user_id === value.earlyMsgSenderID,
                      )?.name ?? ""}
                      , {timestampToDateTime(value.earlyMsgTimestamp)}
                    </div>
                  </div>
                </h3>
              ) : (
                <h3 className="Name-messenger">
                  {username}
                  <div className="time">
                    {timestampToDateTime(value.timestamp)}
                  </div>
                </h3>
              )}

              {value.attachments !== undefined &&
              value.attachments.length > 0 &&
              value.message === "c2-attach-files" ? (
                <div className="d-flex file_send_info gap-10 flex-wrap">
                  {value?.attachment_caption ? (
                    <div className="file_send_info_inner">
                      <div className="d-flex flex-wrap gap-y-10">
                        {value.attachments.map(
                          (attachmentItem, attachmentIndex) => {
                            return (
                              <div className="w-100" key={attachmentIndex}>
                                {/* eslint-disable-next-line indent */}
                                {/* eslint-disable-next-line indent */}
                                <AttachmentsFiles
                                  attachmentItem={attachmentItem}
                                  messageDetail={value}
                                />
                              </div>
                            );
                          },
                        )}
                      </div>

                      <div>
                        {value?.attachment_caption && (
                          <span>
                            <p
                              className="break-words"
                              dangerouslySetInnerHTML={{
                                __html: value?.attachment_caption,
                              }}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                  ) : (
                    value.attachments.map((attachmentItem, attachmentIndex) => {
                      return (
                        <div className="w-100" key={attachmentIndex}>
                          {/* eslint-disable-next-line indent */}
                          {/* eslint-disable-next-line indent */}
                          <AttachmentsFiles
                            attachmentItem={attachmentItem}
                            messageDetail={value}
                          />
                        </div>
                      );
                    })
                  )}
                </div>
              ) : IsNewLineExist !== null ? (
                <>
                  {newMessage?.split("\n").map((str, index) => (
                    <>
                      <div
                        key={index}
                        className="d-flex file_send_info gap-10 flex-wrap"
                      >
                        <p dangerouslySetInnerHTML={{ __html: str }} />
                        {previewLinkIcon(value)}
                        {value.edited === true &&
                          index === lengthOfSplitMessage - 1 && (
                            <p className="edit_message_display">(edited)</p>
                          )}
                      </div>
                    </>
                  ))}
                  {value?.preview ? UrlPreview(value?.preview) : null}
                </>
              ) : (
                <>
                  <div className="d-flex file_send_info gap-10 flex-wrap">
                    <p
                      className="break-words"
                      dangerouslySetInnerHTML={{
                        __html:
                          value.preview &&
                          Array.isArray(value.preview) &&
                          value.preview.length > 0
                            ? value.message_array.join(" ")
                            : value.message,
                      }}
                    />
                    {previewLinkIcon(value)}
                    {value.edited === true && (
                      <p className="edit_message_display">(edited)</p>
                    )}
                  </div>
                  {value?.preview ? UrlPreview(value?.preview) : null}
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className={`chat_actions ${
            pinnedActionsId === value.id ? "display_flex" : "display_none"
          }`}
        >
          <div className="chat_actions_span">
            <div className="dropdown">
              <a
                className="justify-content-center dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded={pinnedActionsId === value.id}
                onClick={(e) => {
                  e.stopPropagation();
                  pinnedActionHandler(value.id);
                }}
              >
                <svg width="4px" viewBox="10 4 4 16">
                  <path
                    fill="#b8c0c9"
                    d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                  ></path>
                </svg>
              </a>
            </div>
            {pinnedActionsId === value.id && (
              <ul
                className="chat_actions_dropdown flex-column dropdown-menu"
                aria-labelledby="dropdownMenuButton"
                ref={actionRef}
              >
                <li
                  className="chat_actions_li"
                  onClick={(e) => {
                    e.stopPropagation();
                    // handleUnpinMessage(value);
                    handleUnpinAlert(value);
                  }}
                >
                  <a className="chat_actions_tag">Unpin</a>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
      {showUnpin && (
        <ChatUnpinAlert
          showUnpin={showUnpin}
          handleClose={() => setShowUnpin(false)}
          unpinData={unpinData}
          userInfo={{ name: username, image: useravtar }}
          selectedLanguage={selectedLanguage}
          handleUnpinMessage={handleUnpinMessage}
        />
      )}
    </>
  );
};

export default ChatboardPinnedIncoming;
